// extracted by mini-css-extract-plugin
export default {"modal":"TPhWDtEc3OyixxG8oViV","loadingWrapper":"dsp3umQQVTxMoOtfoGJ4"};